import { atom, computed } from 'nanostores';

export interface ConnectionTimeoutState {
  isWarning: boolean;
  remainingMs: number;
  disconnectAt: string | null;
  message: string | null;
  isTimedOut: boolean;
  timeoutReason: string | null;
}

const DEFAULT_STATE: ConnectionTimeoutState = {
  isWarning: false,
  remainingMs: 0,
  disconnectAt: null,
  message: null,
  isTimedOut: false,
  timeoutReason: null,
};

export const $connectionTimeout = atom<ConnectionTimeoutState>(DEFAULT_STATE);

export const $showTimeoutBanner = computed($connectionTimeout, (state) => state.isWarning || state.isTimedOut);

export function setTimeoutWarning(data: { remainingMs: number; disconnectAt: string; message: string }) {
  $connectionTimeout.set({
    isWarning: true,
    remainingMs: data.remainingMs,
    disconnectAt: data.disconnectAt,
    message: data.message,
    isTimedOut: false,
    timeoutReason: null,
  });
}

export function setTimedOut(reason: string) {
  $connectionTimeout.set({
    isWarning: false,
    remainingMs: 0,
    disconnectAt: null,
    message: null,
    isTimedOut: true,
    timeoutReason: reason,
  });
}

export function clearTimeoutState() {
  $connectionTimeout.set(DEFAULT_STATE);
}

export function updateRemainingTime(remainingMs: number) {
  const current = $connectionTimeout.get();

  if (current.isWarning) {
    $connectionTimeout.set({
      ...current,
      remainingMs,
    });
  }
}
